(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["usha-wallet-landing"] && !Shopify.designMode) return;
  try {
    

    // Elements selectors
    const form = document.querySelector('#personalization-form');
    const nameInput = document.querySelector('#personalized-name');
    const nameCount = document.querySelector('#name-count');
    const nameError = document.querySelector('#name-error');
    const liveName = document.querySelector('#live-name');
    const selectedColorText = document.querySelector('#selected-color');
    const stage = document.querySelector('#product-stage');
    const stageImage = document.querySelector('#stage-image');
    const stageVideo = document.querySelector('#stage-video');
    const stageLabel = document.querySelector('#stage-label');
    const studioBuy = document.querySelector('#studio-buy');
    
    // Plate overlay element
    const studioPlate = document.querySelector('#studio-plate');
    const fontProperty = document.querySelector('#font-property');
    
    // Sticky bottom bar elements
    const stickyBuyBar = document.querySelector('#sticky-buy');
    const stickyPriceDisplay = document.querySelector('#sticky-price-display');
    const stickySummaryText = document.querySelector('#sticky-summary-text');
    const stickyActionBtn = document.querySelector('#sticky-action');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    let activeColor = 'Black';
    let addHeart = false;
    let paymentMethod = 'prepaid';
    let activeFont = 'corsiva'; // 'corsiva' or 'arial'

    // Tracking utility
    window.dataLayer = window.dataLayer || [];
    const track = (event, detail = {}) => window.dataLayer.push({ event, ...detail });

    // Validate Input Name - English letters and spaces only, keep casing
    const cleanName = (val) => val.replace(/[^A-Za-z ]/g, '').replace(/\s{2,}/g, ' ').slice(0, 12);
    const isValidName = () => {
      const trimmed = nameInput.value.trim();
      return /^[A-Za-z ]{1,12}$/.test(trimmed);
    };

    // Live update prices and sticky CTA
    const updateCtaAndPrices = () => {
      const name = nameInput.value.trim();
      const ready = isValidName();
      const price = paymentMethod === 'prepaid' ? 249 : 299;
      
      // Update main form submit button
      if (ready) {
        studioBuy.disabled = false;
        studioBuy.querySelector('span').textContent = `Order Now - \u20b9${price}`;
      } else {
        studioBuy.disabled = true;
        studioBuy.querySelector('span').textContent = 'Enter Name To Customize';
      }

      // Update sticky bottom buy bar
      stickyPriceDisplay.textContent = `\u20b9${price}`;
      if (ready) {
        stickySummaryText.textContent = `${activeColor} | ${name}${addHeart ? ' \u2665' : ''}`;
        stickyActionBtn.textContent = 'Buy Now';
      } else {
        stickySummaryText.textContent = `Save \u20b950 | \u20b9299 COD available`;
        stickyActionBtn.textContent = 'Customize';
      }
    };

    // Setup color choices click event
    document.querySelectorAll('.color-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.color-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeColor = button.dataset.color;
        stageLabel.textContent = activeColor;
        selectedColorText.textContent = `Selected: ${activeColor}`;
        
        // Transition images
        stageImage.src = button.dataset.image;
        
        // Apply color-specific coordinates to the nameplate wrapper
        studioPlate.setAttribute('style', button.dataset.platePos);

        updateCtaAndPrices();
        track('usha_wallet_variant_select', { color: activeColor });
      });
    });

    // Font selection click event
    document.querySelectorAll('.font-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.font-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeFont = button.dataset.font;
        fontProperty.value = activeFont === 'corsiva' ? 'Monotype Corsiva' : 'Arial';
        
        // Update live preview styling
        if (activeFont === 'corsiva') {
          liveName.className = 'studio-plate-text font-style-corsiva';
        } else {
          liveName.className = 'studio-plate-text font-style-arial';
        }
        
        track('usha_wallet_font_select', { font: fontProperty.value });
      });
    });

    // Name Input Listener (keeping casing)
    nameInput.addEventListener('input', () => {
      const cleaned = cleanName(nameInput.value);
      if (cleaned !== nameInput.value) {
        nameInput.value = cleaned;
      }
      
      nameCount.textContent = `${nameInput.value.length} / 12`;
      
      // Update plate text with exact casing
      const renderedText = nameInput.value.trim();
      liveName.textContent = renderedText || 'Your Name';
      
      // Trigger laser spark animation if typing
      if (renderedText.length > 0) {
        triggerSparks();
        
        // Dynamic laser sweep line along plate width
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) {
          const charLen = renderedText.length;
          // Sweep coordinates: from left 38.5% to 86.5% width
          const plateLeft = 38.5;
          const plateWidth = 47.0;
          const pos = plateLeft + (charLen / 12) * plateWidth;
          
          laserSweep.style.left = `${pos}%`;
          laserSweep.classList.add('is-active');
          
          clearTimeout(nameInput.laserTimeout);
          nameInput.laserTimeout = setTimeout(() => {
            laserSweep.classList.remove('is-active');
          }, 450);
        }
      } else {
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) laserSweep.classList.remove('is-active');
      }
      
      nameError.textContent = '';
      updateCtaAndPrices();
    });

    // Heart choices listener
    document.querySelectorAll('.heart-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.heart-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        addHeart = button.dataset.heart === 'true';
        document.querySelector('#heart-property').value = addHeart ? 'Yes' : 'No';
        
        // Update overlay text
        const nameVal = nameInput.value.trim();
        if (nameVal) {
          liveName.textContent = nameVal + (addHeart ? ' \u2665' : '');
        } else {
          liveName.textContent = 'Your Name' + (addHeart ? ' \u2665' : '');
        }

        updateCtaAndPrices();
        track('usha_wallet_heart_select', { add_heart: addHeart });
      });
    });

    // Interactive prepaid vs cod card selection
    document.querySelectorAll('.payment-toggle-card').forEach((card) => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.payment-toggle-card').forEach((c) => c.classList.remove('is-active'));
        card.classList.add('is-active');
        paymentMethod = card.dataset.method;
        
        updateCtaAndPrices();
        track('usha_wallet_payment_method_select', { method: paymentMethod });
      });
    });

    // Form Submission / Checkout Simulator
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!isValidName()) {
        nameError.textContent = 'Please enter between 1 to 12 English letters.';
        nameInput.focus();
        return;
      }
      
      const price = paymentMethod === 'prepaid' ? 249 : 299;
      track('usha_wallet_checkout_start', {
        color: activeColor,
        name: nameInput.value.trim(),
        font: fontProperty.value,
        heart: addHeart,
        payment: paymentMethod,
        price: price
      });

      alert(`Checkout Simulator:\n\nProcessing order for ${nameInput.value.trim()} (${activeColor})\nFont style: ${fontProperty.value}\nMethod: ${paymentMethod.toUpperCase()}\nPrice: \u20b9${price}\n\nRedirecting to secure shopify checkouts...`);
    });

    // Focus Studio helper
    const focusStudio = () => {
      document.querySelector('#personalize').scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
      window.setTimeout(() => nameInput.focus({ preventScroll: true }), reduceMotion ? 0 : 600);
    };

    // Hero Background Video intersection controls
    const heroBgVideo = document.querySelector('#hero-bg-video');
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!reduceMotion) heroBgVideo.play().catch(() => {});
        } else {
          heroBgVideo.pause();
        }
      });
    }, { threshold: 0.15 });
    if (heroBgVideo) heroObserver.observe(heroBgVideo);

    // V3 Scroll Linked Detail Cards Stage observer
    const detailImages = document.querySelectorAll('[data-detail-image]');
    const scrollStoryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const targetKey = entry.target.dataset.detail;
        
        detailImages.forEach((img) => {
          img.classList.toggle('is-active', img.dataset.detailImage === targetKey);
        });
        
        document.querySelectorAll('[data-detail]').forEach((step) => {
          step.classList.toggle('is-active', step === entry.target);
        });
      });
    }, { rootMargin: '-35% 0px -40% 0px', threshold: 0 });
    document.querySelectorAll('[data-detail]').forEach((step) => scrollStoryObserver.observe(step));

    // Sticky Buy Bar scroll visibility trigger
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyBuyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(document.querySelector('.hero .primary-button'));

    // Scroll reveal fade effects
    const revealItems = document.querySelectorAll('[data-reveal]');
    if (reduceMotion) {
      revealItems.forEach((el) => el.style.opacity = '1');
    } else {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      revealItems.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
        revealObserver.observe(el);
      });
    }

    // Numbers rolling count animated counters
    const counterElements = document.querySelectorAll('[data-count-to]');
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') return;
        entry.target.dataset.counted = 'true';
        const target = Number(entry.target.dataset.countTo);
        const start = performance.now();
        const duration = 1500;
        
        const countFn = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4); // Quartic ease out
          entry.target.textContent = Math.round(target * eased).toLocaleString('en-IN');
          
          if (progress < 1) {
            requestAnimationFrame(countFn);
          }
        };
        
        if (reduceMotion) {
          entry.target.textContent = target.toLocaleString('en-IN');
        } else {
          requestAnimationFrame(countFn);
        }
      });
    }, { threshold: 0.3 });
    counterElements.forEach((el) => countObserver.observe(el));

    // Custom FAQs triggers (Slide height)
    document.querySelectorAll('.faq-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq-item');
        const content = item.querySelector('.faq-content');
        const icon = trigger.querySelector('.faq-icon');
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close others
        document.querySelectorAll('.faq-item').forEach((otherItem) => {
          if (otherItem === item) return;
          otherItem.querySelector('.faq-trigger').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.faq-content').style.maxHeight = null;
          otherItem.querySelector('.faq-icon').textContent = '+';
        });

        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = null;
          icon.textContent = '+';
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
          icon.textContent = '\u2212';
        }
      });
    });

    // Before/After comparison slider drag and autoplay handling
    const slider = document.querySelector('#comparison-slider');
    const afterPanel = document.querySelector('#comparison-after-panel');
    const dragHandle = document.querySelector('#comparison-drag-handle');
    
    let isDragging = false;
    let autoplayActive = true;
    let autoplayTime = 0;

    const setSliderPos = (xPos) => {
      const rect = slider.getBoundingClientRect();
      const relativeX = Math.max(0, Math.min(xPos - rect.left, rect.width));
      const percentage = (relativeX / rect.width) * 100;
      
      afterPanel.style.width = `${percentage}%`;
      dragHandle.style.left = `${percentage}%`;
    };

    const startDrag = () => { 
      isDragging = true; 
      autoplayActive = false; 
    };
    const stopDrag = () => { isDragging = false; };
    
    const dragMove = (e) => {
      if (!isDragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setSliderPos(clientX);
    };

    dragHandle.addEventListener('mousedown', startDrag);
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('mousemove', dragMove);
    
    dragHandle.addEventListener('touchstart', startDrag);
    window.addEventListener('touchend', stopDrag);
    window.addEventListener('touchmove', dragMove);

    // Stop autoplay when user interacts
    slider.addEventListener('mouseenter', () => { autoplayActive = false; });
    slider.addEventListener('touchstart', () => { autoplayActive = false; });

    // Autoplay sweep loop (sine wave oscillation)
    const autoplayLoop = () => {
      if (!autoplayActive) return;
      autoplayTime += 0.012; // Speed of sweep
      const sweepPercentage = 50 + Math.sin(autoplayTime) * 28; // swing from 22% to 78%
      afterPanel.style.width = `${sweepPercentage}%`;
      dragHandle.style.left = `${sweepPercentage}%`;
      requestAnimationFrame(autoplayLoop);
    };
    requestAnimationFrame(autoplayLoop);

    // Social Proof Toast activity ticker loop
    const ticker = document.querySelector('#purchase-ticker');
    const tickerName = document.querySelector('#ticker-name');
    const tickerAction = document.querySelector('#ticker-action');

    const customerNames = [
      'Rahul from Mumbai', 'Amit from Vadodara', 'Siddharth from Delhi', 
      'Vikram from Ahmedabad', 'Karan from Pune', 'Arjun from Bangalore', 
      'Dev from Surat', 'Rohan from Indore', 'Raj from Jaipur'
    ];
    const colorCombos = [
      'ordered Tan Brown Wallet Set', 'ordered Navy Blue Wallet Set', 
      'personalized Black Wallet Set', 'ordered Dark Brown Wallet Set'
    ];

    const runSocialTicker = () => {
      const name = customerNames[Math.floor(Math.random() * customerNames.length)];
      const combo = colorCombos[Math.floor(Math.random() * colorCombos.length)];
      
      tickerName.textContent = name;
      tickerAction.textContent = `${combo}!`;
      
      ticker.classList.add('is-active');
      
      setTimeout(() => {
        ticker.classList.remove('is-active');
      }, 4000);
    };

    setInterval(runSocialTicker, 14000);
    setTimeout(runSocialTicker, 4000); // First run after 4s

    // Floating trust pill logic
    const trustPill = document.querySelector('.floating-trust-pill');
    const trustText = document.querySelector('#trust-pill-text');
    const trustPhrases = [
      '\u2605 4.9 Buyer Rating',
      '\ud83d\ude9a Free India Shipping',
      '\ud83c\udf81 Premium Gift Box Included',
      '\ud83c\uddee\ud83c\uddf3 Handcrafted In Vadodara'
    ];
    let phraseIdx = 0;
    setInterval(() => {
      if (trustText) {
        trustText.style.opacity = '0';
        setTimeout(() => {
          phraseIdx = (phraseIdx + 1) % trustPhrases.length;
          trustText.textContent = trustPhrases[phraseIdx];
          trustText.style.opacity = '1';
        }, 300);
      }
    }, 4000);

    window.addEventListener('scroll', () => {
      if (trustPill) {
        if (window.scrollY > 220) {
          trustPill.classList.add('is-visible');
        } else {
          trustPill.classList.remove('is-visible');
        }
      }
    });

    // Hotspot tooltips logic
    document.querySelectorAll('.hotspot').forEach(el => {
      const tooltipText = el.dataset.tooltip;
      const tooltip = document.createElement('div');
      tooltip.className = 'hotspot-tooltip';
      tooltip.textContent = tooltipText;
      el.appendChild(tooltip);
      
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const isActive = el.classList.contains('is-active');
        document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
        if (!isActive) el.classList.add('is-active');
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
    });

    // Video modal logic
    const videoModal = document.querySelector('#video-modal');
    const modalVideo = document.querySelector('#modal-video-player');
    const modalClose = document.querySelector('.video-modal-close');
    const backdrop = document.querySelector('.video-modal-backdrop');

    window.openVideoModal = (videoSrc) => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        mv.src = videoSrc;
        vm.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        mv.load();
        mv.play().catch(() => {});
        track('usha_video_unboxing_play', { src: videoSrc });
      }
    };

    const closeVideoModal = () => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        vm.classList.remove('is-active');
        mv.pause();
        mv.src = '';
        document.body.style.overflow = '';
      }
    };

    if (modalClose) modalClose.addEventListener('click', closeVideoModal);
    if (backdrop) backdrop.addEventListener('click', closeVideoModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeVideoModal();
    });

    // Custom Canvas Particle Spark Emitter inside Customizer Stage
    const canvas = document.querySelector('#sparks-canvas');
    const ctx = canvas.getContext('2d');
    
    let canvasWidth = canvas.offsetWidth;
    let canvasHeight = canvas.offsetHeight;
    
    const resizeCanvas = () => {
      canvasWidth = stage.offsetWidth;
      canvasHeight = stage.offsetHeight;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    let particles = [];

    class SparkParticle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.vx = (Math.random() - 0.5) * 3;
        this.vy = (Math.random() - 0.7) * 3 - 0.8;
        this.size = Math.random() * 2 + 1;
        this.alpha = 1;
        this.fade = Math.random() * 0.04 + 0.03;
        this.color = `rgba(255, ${Math.floor(Math.random() * 80 + 175)}, 80, `;
      }
      
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.fade;
      }
      
      draw() {
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = this.color + this.alpha + ')';
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    const animateParticles = () => {
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      
      particles.forEach((p, idx) => {
        p.update();
        p.draw();
        if (p.alpha <= 0) {
          particles.splice(idx, 1);
        }
      });
      
      if (particles.length > 0) {
        requestAnimationFrame(animateParticles);
      }
    };

    const triggerSparks = () => {
      const plateRect = studioPlate.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      
      const relativeX = plateRect.left - stageRect.left + (plateRect.width * 0.7);
      const relativeY = plateRect.top - stageRect.top + (plateRect.height * 0.5);

      for (let i = 0; i < 8; i++) {
        particles.push(new SparkParticle(relativeX, relativeY));
      }
      
      if (particles.length === 8) {
        requestAnimationFrame(animateParticles);
      }
    };

    // \u2500\u2500 Card Autoplay (Instagram-style muted preview) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    const cardAutoplayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const preview = card.querySelector('.slot-preview');
        if (!preview) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // Card is 50%+ visible \u2014 start muted preview
          preview.play().then(() => {
            card.classList.add('is-playing');
          }).catch(() => {});
        } else {
          // Card scrolled out \u2014 pause and reset
          preview.pause();
          preview.currentTime = 0;
          card.classList.remove('is-playing');
        }
      });
    }, {
      threshold: 0.5  // fires when 50% of card is visible
    });

    // Observe all media-slot cards that have a preview video
    document.querySelectorAll('.media-slot[data-video-src]').forEach((card) => {
      cardAutoplayObserver.observe(card);
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usha-wallet-v4"] && !Shopify.designMode) return;
  try {
    

    // Elements selectors
    const form = document.querySelector('[data-wallet-form]');
    const nameInput = document.querySelector('#personalized-name');
    const nameCount = document.querySelector('#name-count');
    const nameError = document.querySelector('#name-error');
    const liveName = document.querySelector('#live-name');
    const selectedColorText = document.querySelector('#selected-color');
    const stage = document.querySelector('#product-stage');
    const stageImage = document.querySelector('#stage-image');
    const stageVideo = document.querySelector('#stage-video');
    const stageLabel = document.querySelector('#stage-label');
    const studioBuy = document.querySelector('#studio-buy');
    const addAnotherButton = document.querySelector('#add-another-wallet');
    const quantityInput = document.querySelector('#wallet-quantity');
    const cartButton = document.querySelector('#wallet-cart-button');
    const cartCountDisplay = document.querySelector('[data-cart-count-display]');
    const variantInput = document.querySelector('#active-variant-id');
    
    // Plate overlay element
    const studioPlate = document.querySelector('#studio-plate');
    const fontProperty = document.querySelector('#font-property');
    const paymentProperty = document.querySelector('#payment-property');
    
    // Sticky bottom bar elements
    const stickyBuyBar = document.querySelector('#sticky-buy');
    const stickyPriceDisplay = document.querySelector('#sticky-price-display');
    const stickySummaryText = document.querySelector('#sticky-summary-text');
    const stickyActionBtn = document.querySelector('#sticky-action');
    const translationTemplate = document.querySelector('[data-wallet-translations]');
    const getSetting = (key, fallback = '') => {
      const element = translationTemplate?.content.querySelector(`[data-key="${key}"]`);
      return element?.textContent.trim() || fallback;
    };
    const prepaidPrice = Number(getSetting('prepaidPrice', '249'));
    const codPrice = Number(getSetting('codPrice', '299'));
    const stickyPlaceholder = getSetting('stickyPlaceholder', 'Save Rs. 50 | COD available');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    let activeColor = 'Black';
    let addHeart = false;
    let paymentMethod = 'prepaid';
    let activeFont = 'corsiva'; // 'corsiva' or 'arial'
    let activeVariantAvailable = document.querySelector('.color-choice.is-active')?.dataset.available !== 'false';
    let checkoutLocked = false;
    let checkoutMode = 'checkout';

    // Tracking utility
    window.dataLayer = window.dataLayer || [];
    const track = (event, detail = {}) => window.dataLayer.push({ event, ...detail });

    // Validate Input Name - English letters and spaces only, keep casing
    const cleanName = (val) => val.replace(/[^A-Za-z ]/g, '').replace(/\s{2,}/g, ' ').slice(0, 12);
    const isValidName = () => {
      const trimmed = nameInput.value.trim();
      return /^[A-Za-z ]{1,12}$/.test(trimmed);
    };

    // Live update prices and sticky CTA
    const updateCtaAndPrices = () => {
      const name = nameInput.value.trim();
      const ready = isValidName();
      const price = paymentMethod === 'prepaid' ? prepaidPrice : codPrice;

      stickyPriceDisplay.textContent = `\u20b9${price}`;

      if (checkoutLocked) {
        const loadingText = checkoutMode === 'checkout'
          ? 'Opening Secure Checkout...'
          : 'Adding Personalized Wallet...';
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        stickyActionBtn.disabled = true;
        studioBuy.setAttribute('aria-busy', 'true');
        stickyActionBtn.setAttribute('aria-busy', 'true');
        studioBuy.querySelector('span').textContent = loadingText;
        stickyActionBtn.textContent = checkoutMode === 'checkout' ? 'Opening Checkout...' : 'Adding...';
        stickySummaryText.textContent = `${activeColor} | ${name}${addHeart ? ' \u2665' : ''}`;
        return;
      }

      studioBuy.setAttribute('aria-busy', 'false');
      stickyActionBtn.setAttribute('aria-busy', 'false');
      stickyActionBtn.disabled = false;
      
      // Update main form submit button
      if (ready && activeVariantAvailable) {
        studioBuy.disabled = false;
        addAnotherButton.disabled = false;
        studioBuy.querySelector('span').textContent = paymentMethod === 'prepaid'
          ? `Order & Unlock \u20b9${price} Prepaid`
          : `Order \u20b9${price} COD`;
      } else if (!activeVariantAvailable) {
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        studioBuy.querySelector('span').textContent = 'Selected Color Sold Out';
      } else {
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        studioBuy.querySelector('span').textContent = 'Enter Name To Customize';
      }

      // Update sticky bottom buy bar
      if (ready && activeVariantAvailable) {
        stickySummaryText.textContent = `${activeColor} | ${name}${addHeart ? ' \u2665' : ''}`;
        stickyActionBtn.textContent = 'Buy Now';
      } else if (!activeVariantAvailable) {
        stickySummaryText.textContent = `${activeColor} is currently sold out`;
        stickyActionBtn.textContent = 'Choose Color';
      } else {
        stickySummaryText.textContent = stickyPlaceholder;
        stickyActionBtn.textContent = 'Customize';
      }
    };

    const closeMobileKeyboard = () => {
      if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
      nameInput.blur();
    };

    const normalizeQuantity = () => {
      const quantity = Math.max(1, Math.min(10, Number.parseInt(quantityInput.value, 10) || 1));
      quantityInput.value = String(quantity);
      return quantity;
    };

    document.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        quantityInput.value = String(normalizeQuantity() + Number(button.dataset.quantityChange));
        normalizeQuantity();
      });
    });
    quantityInput.addEventListener('change', normalizeQuantity);

    // Setup color choices click event
    document.querySelectorAll('.color-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.color-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeColor = button.dataset.color;
        activeVariantAvailable = button.dataset.available !== 'false';
        variantInput.value = button.dataset.variantId;
        stageLabel.textContent = activeColor;
        selectedColorText.textContent = `Selected: ${activeColor}`;
        
        // Transition images
        stageImage.src = button.dataset.image;
        
        // Apply color-specific coordinates to the nameplate wrapper
        studioPlate.setAttribute('style', button.dataset.platePos);

        updateCtaAndPrices();
        track('usha_wallet_variant_select', { color: activeColor });
      });
    });

    // Font selection click event
    document.querySelectorAll('.font-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.font-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeFont = button.dataset.font;
        fontProperty.value = activeFont === 'corsiva' ? 'Monotype Corsiva' : 'Arial';
        
        // Update live preview styling
        if (activeFont === 'corsiva') {
          liveName.className = 'studio-plate-text font-style-corsiva';
        } else {
          liveName.className = 'studio-plate-text font-style-arial';
        }
        
        track('usha_wallet_font_select', { font: fontProperty.value });
      });
    });

    // Name Input Listener (keeping casing)
    nameInput.addEventListener('input', () => {
      const cleaned = cleanName(nameInput.value);
      if (cleaned !== nameInput.value) {
        nameInput.value = cleaned;
      }
      
      nameCount.textContent = `${nameInput.value.length} / 12`;
      
      // Update plate text with exact casing
      const renderedText = nameInput.value.trim();
      liveName.textContent = renderedText || 'Your Name';
      
      // Trigger laser spark animation if typing
      if (renderedText.length > 0) {
        triggerSparks();
        
        // Dynamic laser sweep line along plate width
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) {
          const charLen = renderedText.length;
          // Sweep coordinates: from left 38.5% to 86.5% width
          const plateLeft = 38.5;
          const plateWidth = 47.0;
          const pos = plateLeft + (charLen / 12) * plateWidth;
          
          laserSweep.style.left = `${pos}%`;
          laserSweep.classList.add('is-active');
          
          clearTimeout(nameInput.laserTimeout);
          nameInput.laserTimeout = setTimeout(() => {
            laserSweep.classList.remove('is-active');
          }, 450);
        }
      } else {
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) laserSweep.classList.remove('is-active');
      }
      
      nameError.textContent = '';
      updateCtaAndPrices();
    });

    // Heart choices listener
    document.querySelectorAll('.heart-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.heart-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        addHeart = button.dataset.heart === 'true';
        document.querySelector('#heart-property').value = addHeart ? 'Yes' : 'No';
        
        // Update overlay text
        const nameVal = nameInput.value.trim();
        if (nameVal) {
          liveName.textContent = nameVal + (addHeart ? ' \u2665' : '');
        } else {
          liveName.textContent = 'Your Name' + (addHeart ? ' \u2665' : '');
        }

        updateCtaAndPrices();
        track('usha_wallet_heart_select', { add_heart: addHeart });
      });
    });

    // Interactive prepaid vs cod card selection
    document.querySelectorAll('.payment-toggle-card').forEach((card) => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.payment-toggle-card').forEach((c) => {
          c.classList.remove('is-active');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('is-active');
        card.setAttribute('aria-checked', 'true');
        paymentMethod = card.dataset.method;
        paymentProperty.value = paymentMethod === 'prepaid'
          ? 'Convert to prepaid after ordering'
          : 'Keep Cash on Delivery';
        
        updateCtaAndPrices();
        track('usha_wallet_payment_method_select', { method: paymentMethod });
      });
    });

    const validateConfiguration = () => {
      if (!isValidName()) {
        nameError.textContent = 'Please enter between 1 to 12 English letters.';
        nameInput.focus();
        return false;
      }
      if (!activeVariantAvailable) {
        nameError.textContent = 'Please choose an available color.';
        return false;
      }
      return true;
    };

    const addConfiguredWallet = async (redirectToCheckout) => {
      if (checkoutLocked) return false;
      if (!validateConfiguration()) return false;
      closeMobileKeyboard();
      checkoutMode = redirectToCheckout ? 'checkout' : 'cart';
      checkoutLocked = true;
      updateCtaAndPrices();
      
      const price = paymentMethod === 'prepaid' ? prepaidPrice : codPrice;
      track('usha_wallet_checkout_start', {
        color: activeColor,
        name: nameInput.value.trim(),
        font: fontProperty.value,
        heart: addHeart,
        payment: paymentMethod,
        price: price,
        quantity: normalizeQuantity()
      });

      const shopRoot = window.Shopify?.routes?.root || '/';
      const controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      const requestOptions = {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: new FormData(form)
      };
      if (controller) requestOptions.signal = controller.signal;
      const timeoutId = controller ? window.setTimeout(() => controller.abort(), 15000) : null;

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, requestOptions);
        if (timeoutId) window.clearTimeout(timeoutId);
        const responseText = await response.text();
        let result = {};
        if (responseText) {
          try {
            result = JSON.parse(responseText);
          } catch (parseError) {
            result = {};
          }
        }
        if (!response.ok) throw new Error(result.description || 'Cart request failed');
        track('usha_wallet_cart_add_success', { color: activeColor, payment: paymentMethod });
        if (redirectToCheckout) {
          stickyActionBtn.textContent = 'Redirecting...';
          window.location.replace(`${shopRoot}checkout`);
          return true;
        }

        const cartResponse = await fetch(`${shopRoot}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        const cart = await cartResponse.json();
        cartCountDisplay.textContent = String(cart.item_count || 0);
        checkoutLocked = false;
        nameInput.value = '';
        quantityInput.value = '1';
        liveName.textContent = 'Your Name';
        nameCount.textContent = '0 / 12';
        nameError.textContent = 'Added. Choose the next color and enter its name.';
        updateCtaAndPrices();
        document.querySelector('#personalize').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        return true;
      } catch (error) {
        if (timeoutId) window.clearTimeout(timeoutId);
        checkoutLocked = false;
        updateCtaAndPrices();
        nameError.textContent = error.name === 'AbortError'
          ? 'Checkout took too long to respond. Please check your connection and try once more.'
          : 'We could not start checkout. Please try again.';
        track('usha_wallet_cart_add_error', { message: error.message });
        return false;
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addConfiguredWallet(true);
    });

    addAnotherButton.addEventListener('click', () => addConfiguredWallet(false));

    // Scroll to the studio without forcing the mobile keyboard open.
    const focusStudio = () => {
      closeMobileKeyboard();
      document.querySelector('#personalize').scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    };
    document.querySelectorAll('.js-focus-studio').forEach((button) => button.addEventListener('click', focusStudio));

    stickyActionBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (checkoutLocked) return;
      if (isValidName() && activeVariantAvailable) {
        closeMobileKeyboard();
        addConfiguredWallet(true);
      } else {
        focusStudio();
      }
    });

    window.addEventListener('pageshow', () => {
      checkoutLocked = false;
      checkoutMode = 'checkout';
      updateCtaAndPrices();
    });

    cartButton.addEventListener('click', async () => {
      closeMobileKeyboard();
      const itemCount = Number.parseInt(cartCountDisplay.textContent, 10) || 0;
      if (itemCount > 0) {
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } else {
        focusStudio();
      }
    });

    fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => { cartCountDisplay.textContent = String(cart.item_count || 0); })
      .catch(() => {});

    // Hero Background Video intersection controls
    const heroBgVideo = document.querySelector('#hero-bg-video');
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!reduceMotion) heroBgVideo.play().catch(() => {});
        } else {
          heroBgVideo.pause();
        }
      });
    }, { threshold: 0.15 });
    if (heroBgVideo) heroObserver.observe(heroBgVideo);

    // V3 Scroll Linked Detail Cards Stage observer
    const detailImages = document.querySelectorAll('[data-detail-image]');
    const scrollStoryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const targetKey = entry.target.dataset.detail;
        
        detailImages.forEach((img) => {
          img.classList.toggle('is-active', img.dataset.detailImage === targetKey);
        });
        
        document.querySelectorAll('[data-detail]').forEach((step) => {
          step.classList.toggle('is-active', step === entry.target);
        });
      });
    }, { rootMargin: '-35% 0px -40% 0px', threshold: 0 });
    document.querySelectorAll('[data-detail]').forEach((step) => scrollStoryObserver.observe(step));

    // Sticky Buy Bar scroll visibility trigger
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyBuyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(document.querySelector('.hero .primary-button'));

    // Scroll reveal fade effects
    const revealItems = document.querySelectorAll('[data-reveal]');
    if (reduceMotion) {
      revealItems.forEach((el) => el.style.opacity = '1');
    } else {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      revealItems.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
        revealObserver.observe(el);
      });
    }

    // Numbers rolling count animated counters
    const counterElements = document.querySelectorAll('[data-count-to]');
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') return;
        entry.target.dataset.counted = 'true';
        const target = Number(entry.target.dataset.countTo);
        const start = performance.now();
        const duration = 1500;
        
        const countFn = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4); // Quartic ease out
          entry.target.textContent = Math.round(target * eased).toLocaleString('en-IN');
          
          if (progress < 1) {
            requestAnimationFrame(countFn);
          }
        };
        
        if (reduceMotion) {
          entry.target.textContent = target.toLocaleString('en-IN');
        } else {
          requestAnimationFrame(countFn);
        }
      });
    }, { threshold: 0.3 });
    counterElements.forEach((el) => countObserver.observe(el));

    // Custom FAQs triggers (Slide height)
    document.querySelectorAll('.faq-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq-item');
        const content = item.querySelector('.faq-content');
        const icon = trigger.querySelector('.faq-icon');
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close others
        document.querySelectorAll('.faq-item').forEach((otherItem) => {
          if (otherItem === item) return;
          otherItem.querySelector('.faq-trigger').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.faq-content').style.maxHeight = null;
          otherItem.querySelector('.faq-icon').textContent = '+';
        });

        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = null;
          icon.textContent = '+';
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
          icon.textContent = '\u2212';
        }
      });
    });

    // Before/After comparison slider drag and autoplay handling
    const slider = document.querySelector('#comparison-slider');
    const afterPanel = document.querySelector('#comparison-after-panel');
    const dragHandle = document.querySelector('#comparison-drag-handle');
    
    let isDragging = false;
    let autoplayActive = true;
    let autoplayTime = 0;

    const setSliderPos = (xPos) => {
      const rect = slider.getBoundingClientRect();
      const relativeX = Math.max(0, Math.min(xPos - rect.left, rect.width));
      const percentage = (relativeX / rect.width) * 100;
      
      afterPanel.style.width = `${percentage}%`;
      dragHandle.style.left = `${percentage}%`;
      dragHandle.setAttribute('aria-valuenow', String(Math.round(percentage)));
    };

    const startDrag = () => { 
      isDragging = true; 
      autoplayActive = false; 
    };
    const stopDrag = () => { isDragging = false; };
    
    const dragMove = (e) => {
      if (!isDragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setSliderPos(clientX);
    };

    dragHandle.addEventListener('mousedown', startDrag);
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('mousemove', dragMove);
    
    dragHandle.addEventListener('touchstart', startDrag);
    window.addEventListener('touchend', stopDrag);
    window.addEventListener('touchmove', dragMove);

    // Stop autoplay when user interacts
    slider.addEventListener('mouseenter', () => { autoplayActive = false; });
    slider.addEventListener('touchstart', () => { autoplayActive = false; });
    dragHandle.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      autoplayActive = false;
      const current = Number(dragHandle.getAttribute('aria-valuenow') || 50);
      const next = Math.max(0, Math.min(100, current + (event.key === 'ArrowRight' ? 5 : -5)));
      afterPanel.style.width = `${next}%`;
      dragHandle.style.left = `${next}%`;
      dragHandle.setAttribute('aria-valuenow', String(next));
    });

    // Autoplay sweep loop (sine wave oscillation)
    const autoplayLoop = () => {
      if (!autoplayActive) return;
      autoplayTime += 0.012; // Speed of sweep
      const sweepPercentage = 50 + Math.sin(autoplayTime) * 28; // swing from 22% to 78%
      afterPanel.style.width = `${sweepPercentage}%`;
      dragHandle.style.left = `${sweepPercentage}%`;
      dragHandle.setAttribute('aria-valuenow', String(Math.round(sweepPercentage)));
      requestAnimationFrame(autoplayLoop);
    };
    requestAnimationFrame(autoplayLoop);

    // Floating trust pill logic
    const trustPill = document.querySelector('.floating-trust-pill');
    const trustText = document.querySelector('#trust-pill-text');
    const trustPhrases = [
      'Secure Shopify Checkout',
      'Free India Shipping',
      'Gift Box Included',
      'Personalized In Vadodara'
    ];
    let phraseIdx = 0;
    setInterval(() => {
      if (trustText) {
        trustText.style.opacity = '0';
        setTimeout(() => {
          phraseIdx = (phraseIdx + 1) % trustPhrases.length;
          trustText.textContent = trustPhrases[phraseIdx];
          trustText.style.opacity = '1';
        }, 300);
      }
    }, 4000);

    window.addEventListener('scroll', () => {
      if (trustPill) {
        if (window.scrollY > 220) {
          trustPill.classList.add('is-visible');
        } else {
          trustPill.classList.remove('is-visible');
        }
      }
    });

    // Hotspot tooltips logic
    document.querySelectorAll('.hotspot').forEach(el => {
      const tooltipText = el.dataset.tooltip;
      const tooltip = document.createElement('div');
      tooltip.className = 'hotspot-tooltip';
      tooltip.textContent = tooltipText;
      el.appendChild(tooltip);
      
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const isActive = el.classList.contains('is-active');
        document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
        if (!isActive) el.classList.add('is-active');
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
    });

    // Video modal logic
    const videoModal = document.querySelector('#video-modal');
    const modalVideo = document.querySelector('#modal-video-player');
    const modalClose = document.querySelector('.video-modal-close');
    const backdrop = document.querySelector('.video-modal-backdrop');

    window.openVideoModal = (videoSrc) => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        mv.src = videoSrc;
        vm.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        mv.load();
        mv.play().catch(() => {});
        track('usha_video_unboxing_play', { src: videoSrc });
      }
    };

    const closeVideoModal = () => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        vm.classList.remove('is-active');
        mv.pause();
        mv.src = '';
        document.body.style.overflow = '';
      }
    };

    if (modalClose) modalClose.addEventListener('click', closeVideoModal);
    if (backdrop) backdrop.addEventListener('click', closeVideoModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeVideoModal();
    });

    // Custom Canvas Particle Spark Emitter inside Customizer Stage
    const canvas = document.querySelector('#sparks-canvas');
    const ctx = canvas.getContext('2d');
    
    let canvasWidth = canvas.offsetWidth;
    let canvasHeight = canvas.offsetHeight;
    
    const resizeCanvas = () => {
      canvasWidth = stage.offsetWidth;
      canvasHeight = stage.offsetHeight;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    let particles = [];

    class SparkParticle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.vx = (Math.random() - 0.5) * 3;
        this.vy = (Math.random() - 0.7) * 3 - 0.8;
        this.size = Math.random() * 2 + 1;
        this.alpha = 1;
        this.fade = Math.random() * 0.04 + 0.03;
        this.color = `rgba(255, ${Math.floor(Math.random() * 80 + 175)}, 80, `;
      }
      
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.fade;
      }
      
      draw() {
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = this.color + this.alpha + ')';
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    const animateParticles = () => {
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      
      particles.forEach((p, idx) => {
        p.update();
        p.draw();
        if (p.alpha <= 0) {
          particles.splice(idx, 1);
        }
      });
      
      if (particles.length > 0) {
        requestAnimationFrame(animateParticles);
      }
    };

    const triggerSparks = () => {
      const plateRect = studioPlate.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      
      const relativeX = plateRect.left - stageRect.left + (plateRect.width * 0.7);
      const relativeY = plateRect.top - stageRect.top + (plateRect.height * 0.5);

      for (let i = 0; i < 8; i++) {
        particles.push(new SparkParticle(relativeX, relativeY));
      }
      
      if (particles.length === 8) {
        requestAnimationFrame(animateParticles);
      }
    };

    // \u2500\u2500 Card Autoplay (Instagram-style muted preview) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    const cardAutoplayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const preview = card.querySelector('.slot-preview');
        if (!preview) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          preview.muted = true;
          preview.defaultMuted = true;
          preview.playsInline = true;
          card.classList.add('is-playing');
          preview.play().then(() => {
            card.classList.add('is-playing');
          }).catch(() => {
            card.classList.remove('is-playing');
          });
        } else {
          // Card scrolled out \u2014 pause and reset
          preview.pause();
          preview.currentTime = 0;
          card.classList.remove('is-playing');
        }
      });
    }, {
      threshold: [0, 0.2, 0.5]
    });

    // Observe all media-slot cards that have a preview video
    document.querySelectorAll('.media-slot[data-video-src]').forEach((card) => {
      cardAutoplayObserver.observe(card);
      const openCardVideo = () => window.openVideoModal(card.dataset.videoSrc);
      card.addEventListener('click', openCardVideo);
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openCardVideo();
      });
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usha-wallet-v5"] && !Shopify.designMode) return;
  try {
    

    const studioSection = document.querySelector('#personalize');
    const comparisonSection = document.querySelector('.comparison-section');
    if (studioSection && comparisonSection) {
      comparisonSection.parentNode.insertBefore(studioSection, comparisonSection);
    }

    // Elements selectors
    const form = document.querySelector('[data-wallet-form]');
    const nameInput = document.querySelector('#personalized-name');
    const nameCount = document.querySelector('#name-count');
    const nameError = document.querySelector('#name-error');
    const liveName = document.querySelector('#live-name');
    const selectedColorText = document.querySelector('#selected-color');
    const stage = document.querySelector('#product-stage');
    const stageImage = document.querySelector('#stage-image');
    const stageVideo = document.querySelector('#stage-video');
    const stageLabel = document.querySelector('#stage-label');
    const studioBuy = document.querySelector('#studio-buy');
    const addAnotherButton = document.querySelector('#add-another-wallet');
    const quantityInput = document.querySelector('#wallet-quantity');
    const cartButton = document.querySelector('#wallet-cart-button');
    const cartCountDisplay = document.querySelector('[data-cart-count-display]');
    const variantInput = document.querySelector('#active-variant-id');
    
    // Plate overlay element
    const studioPlate = document.querySelector('#studio-plate');
    const fontProperty = document.querySelector('#font-property');
    
    // Sticky bottom bar elements
    const stickyBuyBar = document.querySelector('#sticky-buy');
    const stickyPriceDisplay = document.querySelector('#sticky-price-display');
    const stickySummaryText = document.querySelector('#sticky-summary-text');
    const stickyActionBtn = document.querySelector('#sticky-action');
    const translationTemplate = document.querySelector('[data-wallet-translations]');
    const getSetting = (key, fallback = '') => {
      const element = translationTemplate?.content.querySelector(`[data-key="${key}"]`);
      return element?.textContent.trim() || fallback;
    };
    const codPrice = Number(getSetting('codPrice', '299'));
    const stickyPlaceholder = getSetting('stickyPlaceholder', 'Free Shipping | Pay On Delivery');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    let activeColor = 'Black';
    let addHeart = false;
    let paymentMethod = 'cod';
    let activeFont = 'corsiva'; // 'corsiva' or 'arial'
    let activeVariantAvailable = document.querySelector('.color-choice.is-active')?.dataset.available !== 'false';
    let checkoutLocked = false;
    let checkoutMode = 'checkout';

    // Tracking utility
    window.dataLayer = window.dataLayer || [];
    const track = (event, detail = {}) => window.dataLayer.push({ event, ...detail });

    // Validate Input Name - English letters and spaces only, keep casing
    const cleanName = (val) => val.replace(/[^A-Za-z ]/g, '').replace(/\s{2,}/g, ' ').slice(0, 12);
    const isValidName = () => {
      const trimmed = nameInput.value.trim();
      return /^[A-Za-z ]{1,12}$/.test(trimmed);
    };

    // Live update prices and sticky CTA
    const updateCtaAndPrices = () => {
      const name = nameInput.value.trim();
      const ready = isValidName();
      const price = codPrice;

      stickyPriceDisplay.textContent = `\u20b9${price}`;

      if (checkoutLocked) {
        const loadingText = checkoutMode === 'checkout'
          ? 'Opening Secure Checkout...'
          : 'Adding Personalized Wallet...';
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        stickyActionBtn.disabled = true;
        studioBuy.setAttribute('aria-busy', 'true');
        stickyActionBtn.setAttribute('aria-busy', 'true');
        studioBuy.querySelector('span').textContent = loadingText;
        stickyActionBtn.textContent = checkoutMode === 'checkout' ? 'Opening Checkout...' : 'Adding...';
        stickySummaryText.textContent = `${activeColor} | ${name}${addHeart ? ' \u2665' : ''}`;
        return;
      }

      studioBuy.setAttribute('aria-busy', 'false');
      stickyActionBtn.setAttribute('aria-busy', 'false');
      stickyActionBtn.disabled = false;
      
      // Update main form submit button
      if (ready && activeVariantAvailable) {
        studioBuy.disabled = false;
        addAnotherButton.disabled = false;
        studioBuy.querySelector('span').textContent = `Order \u20b9${price} COD`;
      } else if (!activeVariantAvailable) {
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        studioBuy.querySelector('span').textContent = 'Selected Color Sold Out';
      } else {
        studioBuy.disabled = true;
        addAnotherButton.disabled = true;
        studioBuy.querySelector('span').textContent = 'Enter Name To Customize';
      }

      // Update sticky bottom buy bar
      if (ready && activeVariantAvailable) {
        stickySummaryText.textContent = `${activeColor} | ${name}${addHeart ? ' \u2665' : ''}`;
        stickyActionBtn.textContent = 'Buy Now';
      } else if (!activeVariantAvailable) {
        stickySummaryText.textContent = `${activeColor} is currently sold out`;
        stickyActionBtn.textContent = 'Choose Color';
      } else {
        stickySummaryText.textContent = stickyPlaceholder;
        stickyActionBtn.textContent = 'Customize';
      }
    };

    const closeMobileKeyboard = () => {
      if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
      nameInput.blur();
    };

    const normalizeQuantity = () => {
      const quantity = Math.max(1, Math.min(10, Number.parseInt(quantityInput.value, 10) || 1));
      quantityInput.value = String(quantity);
      return quantity;
    };

    document.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        quantityInput.value = String(normalizeQuantity() + Number(button.dataset.quantityChange));
        normalizeQuantity();
      });
    });
    quantityInput.addEventListener('change', normalizeQuantity);

    // Setup color choices click event
    document.querySelectorAll('.color-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.color-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeColor = button.dataset.color;
        activeVariantAvailable = button.dataset.available !== 'false';
        variantInput.value = button.dataset.variantId;
        stageLabel.textContent = activeColor;
        selectedColorText.textContent = `Selected: ${activeColor}`;
        
        // Transition images
        stageImage.src = button.dataset.image;
        
        // Apply color-specific coordinates to the nameplate wrapper
        studioPlate.setAttribute('style', button.dataset.platePos);

        updateCtaAndPrices();
        track('usha_wallet_variant_select', { color: activeColor });
      });
    });

    // Font selection click event
    document.querySelectorAll('.font-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.font-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        activeFont = button.dataset.font;
        fontProperty.value = activeFont === 'corsiva' ? 'Monotype Corsiva' : 'Arial';
        
        // Update live preview styling
        if (activeFont === 'corsiva') {
          liveName.className = 'studio-plate-text font-style-corsiva';
        } else {
          liveName.className = 'studio-plate-text font-style-arial';
        }
        
        track('usha_wallet_font_select', { font: fontProperty.value });
      });
    });

    // Name Input Listener (keeping casing)
    nameInput.addEventListener('input', () => {
      const cleaned = cleanName(nameInput.value);
      if (cleaned !== nameInput.value) {
        nameInput.value = cleaned;
      }
      
      nameCount.textContent = `${nameInput.value.length} / 12`;
      
      // Update plate text with exact casing
      const renderedText = nameInput.value.trim();
      liveName.textContent = renderedText || 'Your Name';
      
      // Trigger laser spark animation if typing
      if (renderedText.length > 0) {
        triggerSparks();
        
        // Dynamic laser sweep line along plate width
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) {
          const charLen = renderedText.length;
          // Sweep coordinates: from left 38.5% to 86.5% width
          const plateLeft = 38.5;
          const plateWidth = 47.0;
          const pos = plateLeft + (charLen / 12) * plateWidth;
          
          laserSweep.style.left = `${pos}%`;
          laserSweep.classList.add('is-active');
          
          clearTimeout(nameInput.laserTimeout);
          nameInput.laserTimeout = setTimeout(() => {
            laserSweep.classList.remove('is-active');
          }, 450);
        }
      } else {
        const laserSweep = document.getElementById('laser-sweep');
        if (laserSweep) laserSweep.classList.remove('is-active');
      }
      
      nameError.textContent = '';
      updateCtaAndPrices();
    });

    // Heart choices listener
    document.querySelectorAll('.heart-choice').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.heart-choice').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-checked', 'false');
        });
        
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        
        addHeart = button.dataset.heart === 'true';
        document.querySelector('#heart-property').value = addHeart ? 'Yes' : 'No';
        
        // Update overlay text
        const nameVal = nameInput.value.trim();
        if (nameVal) {
          liveName.textContent = nameVal + (addHeart ? ' \u2665' : '');
        } else {
          liveName.textContent = 'Your Name' + (addHeart ? ' \u2665' : '');
        }

        updateCtaAndPrices();
        track('usha_wallet_heart_select', { add_heart: addHeart });
      });
    });

    const validateConfiguration = () => {
      if (!isValidName()) {
        nameError.textContent = 'Please enter between 1 to 12 English letters.';
        nameInput.focus();
        return false;
      }
      if (!activeVariantAvailable) {
        nameError.textContent = 'Please choose an available color.';
        return false;
      }
      return true;
    };

    const addConfiguredWallet = async (redirectToCheckout) => {
      if (checkoutLocked) return false;
      if (!validateConfiguration()) return false;
      closeMobileKeyboard();
      checkoutMode = redirectToCheckout ? 'checkout' : 'cart';
      checkoutLocked = true;
      updateCtaAndPrices();
      
      const price = codPrice;
      track('usha_wallet_checkout_start', {
        color: activeColor,
        name: nameInput.value.trim(),
        font: fontProperty.value,
        heart: addHeart,
        payment: paymentMethod,
        price: price,
        quantity: normalizeQuantity()
      });

      const shopRoot = window.Shopify?.routes?.root || '/';
      const controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      const requestOptions = {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: new FormData(form)
      };
      if (controller) requestOptions.signal = controller.signal;
      const timeoutId = controller ? window.setTimeout(() => controller.abort(), 15000) : null;

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, requestOptions);
        if (timeoutId) window.clearTimeout(timeoutId);
        const responseText = await response.text();
        let result = {};
        if (responseText) {
          try {
            result = JSON.parse(responseText);
          } catch (parseError) {
            result = {};
          }
        }
        if (!response.ok) throw new Error(result.description || 'Cart request failed');
        track('usha_wallet_cart_add_success', { color: activeColor, payment: paymentMethod });
        if (redirectToCheckout) {
          stickyActionBtn.textContent = 'Redirecting...';
          window.location.replace(`${shopRoot}checkout`);
          return true;
        }

        const cartResponse = await fetch(`${shopRoot}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        const cart = await cartResponse.json();
        cartCountDisplay.textContent = String(cart.item_count || 0);
        checkoutLocked = false;
        nameInput.value = '';
        quantityInput.value = '1';
        liveName.textContent = 'Your Name';
        nameCount.textContent = '0 / 12';
        nameError.textContent = 'Added. Choose the next color and enter its name.';
        updateCtaAndPrices();
        document.querySelector('#personalize').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        return true;
      } catch (error) {
        if (timeoutId) window.clearTimeout(timeoutId);
        checkoutLocked = false;
        updateCtaAndPrices();
        nameError.textContent = error.name === 'AbortError'
          ? 'Checkout took too long to respond. Please check your connection and try once more.'
          : 'We could not start checkout. Please try again.';
        track('usha_wallet_cart_add_error', { message: error.message });
        return false;
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addConfiguredWallet(true);
    });

    addAnotherButton.addEventListener('click', () => addConfiguredWallet(false));

    // Scroll to the studio without forcing the mobile keyboard open.
    const focusStudio = () => {
      closeMobileKeyboard();
      document.querySelector('#personalize').scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    };
    document.querySelectorAll('.js-focus-studio').forEach((button) => button.addEventListener('click', focusStudio));

    stickyActionBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (checkoutLocked) return;
      if (isValidName() && activeVariantAvailable) {
        closeMobileKeyboard();
        addConfiguredWallet(true);
      } else {
        focusStudio();
      }
    });

    window.addEventListener('pageshow', () => {
      checkoutLocked = false;
      checkoutMode = 'checkout';
      updateCtaAndPrices();
    });

    cartButton.addEventListener('click', async () => {
      closeMobileKeyboard();
      const itemCount = Number.parseInt(cartCountDisplay.textContent, 10) || 0;
      if (itemCount > 0) {
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } else {
        focusStudio();
      }
    });

    fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => { cartCountDisplay.textContent = String(cart.item_count || 0); })
      .catch(() => {});

    // Hero Background Video intersection controls
    const heroBgVideo = document.querySelector('#hero-bg-video');
    const startHeroVideo = () => {
      if (!heroBgVideo || reduceMotion) return;
      heroBgVideo.muted = true;
      heroBgVideo.defaultMuted = true;
      heroBgVideo.playsInline = true;
      heroBgVideo.play().catch(() => {});
    };
    startHeroVideo();
    if (heroBgVideo && heroBgVideo.readyState < 2) {
      heroBgVideo.addEventListener('loadeddata', startHeroVideo, { once: true });
      heroBgVideo.addEventListener('canplay', startHeroVideo, { once: true });
    }
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startHeroVideo();
        } else {
          heroBgVideo.pause();
        }
      });
    }, { threshold: 0.15 });
    if (heroBgVideo) heroObserver.observe(heroBgVideo);

    // V3 Scroll Linked Detail Cards Stage observer
    const detailImages = document.querySelectorAll('[data-detail-image]');
    const scrollStoryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const targetKey = entry.target.dataset.detail;
        
        detailImages.forEach((img) => {
          img.classList.toggle('is-active', img.dataset.detailImage === targetKey);
        });
        
        document.querySelectorAll('[data-detail]').forEach((step) => {
          step.classList.toggle('is-active', step === entry.target);
        });
      });
    }, { rootMargin: '-35% 0px -40% 0px', threshold: 0 });
    document.querySelectorAll('[data-detail]').forEach((step) => scrollStoryObserver.observe(step));

    // Sticky Buy Bar scroll visibility trigger
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyBuyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(document.querySelector('.hero .primary-button'));

    // Scroll reveal fade effects
    const revealItems = document.querySelectorAll('[data-reveal]');
    if (reduceMotion) {
      revealItems.forEach((el) => el.style.opacity = '1');
    } else {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      revealItems.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
        revealObserver.observe(el);
      });
    }

    // Numbers rolling count animated counters
    const counterElements = document.querySelectorAll('[data-count-to]');
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') return;
        entry.target.dataset.counted = 'true';
        const target = Number(entry.target.dataset.countTo);
        const start = performance.now();
        const duration = 1500;
        
        const countFn = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4); // Quartic ease out
          entry.target.textContent = Math.round(target * eased).toLocaleString('en-IN');
          
          if (progress < 1) {
            requestAnimationFrame(countFn);
          }
        };
        
        if (reduceMotion) {
          entry.target.textContent = target.toLocaleString('en-IN');
        } else {
          requestAnimationFrame(countFn);
        }
      });
    }, { threshold: 0.3 });
    counterElements.forEach((el) => countObserver.observe(el));

    // Custom FAQs triggers (Slide height)
    document.querySelectorAll('.faq-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq-item');
        const content = item.querySelector('.faq-content');
        const icon = trigger.querySelector('.faq-icon');
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close others
        document.querySelectorAll('.faq-item').forEach((otherItem) => {
          if (otherItem === item) return;
          otherItem.querySelector('.faq-trigger').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.faq-content').style.maxHeight = null;
          otherItem.querySelector('.faq-icon').textContent = '+';
        });

        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = null;
          icon.textContent = '+';
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
          icon.textContent = '\u2212';
        }
      });
    });

    // Before/After comparison slider drag and autoplay handling
    const slider = document.querySelector('#comparison-slider');
    const afterPanel = document.querySelector('#comparison-after-panel');
    const dragHandle = document.querySelector('#comparison-drag-handle');
    
    let isDragging = false;
    let autoplayActive = true;
    let autoplayTime = 0;

    const setSliderPos = (xPos) => {
      const rect = slider.getBoundingClientRect();
      const relativeX = Math.max(0, Math.min(xPos - rect.left, rect.width));
      const percentage = (relativeX / rect.width) * 100;
      
      afterPanel.style.width = `${percentage}%`;
      dragHandle.style.left = `${percentage}%`;
      dragHandle.setAttribute('aria-valuenow', String(Math.round(percentage)));
    };

    const startDrag = () => { 
      isDragging = true; 
      autoplayActive = false; 
    };
    const stopDrag = () => { isDragging = false; };
    
    const dragMove = (e) => {
      if (!isDragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setSliderPos(clientX);
    };

    dragHandle.addEventListener('mousedown', startDrag);
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('mousemove', dragMove);
    
    dragHandle.addEventListener('touchstart', startDrag);
    window.addEventListener('touchend', stopDrag);
    window.addEventListener('touchmove', dragMove);

    // Stop autoplay when user interacts
    slider.addEventListener('mouseenter', () => { autoplayActive = false; });
    slider.addEventListener('touchstart', () => { autoplayActive = false; });
    dragHandle.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      autoplayActive = false;
      const current = Number(dragHandle.getAttribute('aria-valuenow') || 50);
      const next = Math.max(0, Math.min(100, current + (event.key === 'ArrowRight' ? 5 : -5)));
      afterPanel.style.width = `${next}%`;
      dragHandle.style.left = `${next}%`;
      dragHandle.setAttribute('aria-valuenow', String(next));
    });

    // Autoplay sweep loop (sine wave oscillation)
    const autoplayLoop = () => {
      if (!autoplayActive) return;
      autoplayTime += 0.012; // Speed of sweep
      const sweepPercentage = 50 + Math.sin(autoplayTime) * 28; // swing from 22% to 78%
      afterPanel.style.width = `${sweepPercentage}%`;
      dragHandle.style.left = `${sweepPercentage}%`;
      dragHandle.setAttribute('aria-valuenow', String(Math.round(sweepPercentage)));
      requestAnimationFrame(autoplayLoop);
    };
    requestAnimationFrame(autoplayLoop);

    // Floating trust pill logic
    const trustPill = document.querySelector('.floating-trust-pill');
    const trustText = document.querySelector('#trust-pill-text');
    const trustPhrases = [
      'Secure Shopify Checkout',
      'Free India Shipping',
      'Gift Box Included',
      'Personalized In Vadodara'
    ];
    let phraseIdx = 0;
    setInterval(() => {
      if (trustText) {
        trustText.style.opacity = '0';
        setTimeout(() => {
          phraseIdx = (phraseIdx + 1) % trustPhrases.length;
          trustText.textContent = trustPhrases[phraseIdx];
          trustText.style.opacity = '1';
        }, 300);
      }
    }, 4000);

    window.addEventListener('scroll', () => {
      if (trustPill) {
        if (window.scrollY > 220) {
          trustPill.classList.add('is-visible');
        } else {
          trustPill.classList.remove('is-visible');
        }
      }
    });

    // Hotspot tooltips logic
    document.querySelectorAll('.hotspot').forEach(el => {
      const tooltipText = el.dataset.tooltip;
      const tooltip = document.createElement('div');
      tooltip.className = 'hotspot-tooltip';
      tooltip.textContent = tooltipText;
      el.appendChild(tooltip);
      
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const isActive = el.classList.contains('is-active');
        document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
        if (!isActive) el.classList.add('is-active');
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.hotspot').forEach(h => h.classList.remove('is-active'));
    });

    // Video modal logic
    const videoModal = document.querySelector('#video-modal');
    const modalVideo = document.querySelector('#modal-video-player');
    const modalClose = document.querySelector('.video-modal-close');
    const backdrop = document.querySelector('.video-modal-backdrop');

    window.openVideoModal = (videoSrc) => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        mv.src = videoSrc;
        vm.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        mv.load();
        mv.play().catch(() => {});
        track('usha_video_unboxing_play', { src: videoSrc });
      }
    };

    const closeVideoModal = () => {
      const vm = document.querySelector('#video-modal');
      const mv = document.querySelector('#modal-video-player');
      if (vm && mv) {
        vm.classList.remove('is-active');
        mv.pause();
        mv.src = '';
        document.body.style.overflow = '';
      }
    };

    if (modalClose) modalClose.addEventListener('click', closeVideoModal);
    if (backdrop) backdrop.addEventListener('click', closeVideoModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeVideoModal();
    });

    // Custom Canvas Particle Spark Emitter inside Customizer Stage
    const canvas = document.querySelector('#sparks-canvas');
    const ctx = canvas.getContext('2d');
    
    let canvasWidth = canvas.offsetWidth;
    let canvasHeight = canvas.offsetHeight;
    
    const resizeCanvas = () => {
      canvasWidth = stage.offsetWidth;
      canvasHeight = stage.offsetHeight;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    let particles = [];

    class SparkParticle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.vx = (Math.random() - 0.5) * 3;
        this.vy = (Math.random() - 0.7) * 3 - 0.8;
        this.size = Math.random() * 2 + 1;
        this.alpha = 1;
        this.fade = Math.random() * 0.04 + 0.03;
        this.color = `rgba(255, ${Math.floor(Math.random() * 80 + 175)}, 80, `;
      }
      
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.fade;
      }
      
      draw() {
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = this.color + this.alpha + ')';
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    const animateParticles = () => {
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      
      particles.forEach((p, idx) => {
        p.update();
        p.draw();
        if (p.alpha <= 0) {
          particles.splice(idx, 1);
        }
      });
      
      if (particles.length > 0) {
        requestAnimationFrame(animateParticles);
      }
    };

    const triggerSparks = () => {
      const plateRect = studioPlate.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      
      const relativeX = plateRect.left - stageRect.left + (plateRect.width * 0.7);
      const relativeY = plateRect.top - stageRect.top + (plateRect.height * 0.5);

      for (let i = 0; i < 8; i++) {
        particles.push(new SparkParticle(relativeX, relativeY));
      }
      
      if (particles.length === 8) {
        requestAnimationFrame(animateParticles);
      }
    };

    // \u2500\u2500 Card Autoplay (Instagram-style muted preview) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    const cardAutoplayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const preview = card.querySelector('.slot-preview');
        if (!preview) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          preview.muted = true;
          preview.defaultMuted = true;
          preview.playsInline = true;
          card.classList.add('is-playing');
          preview.play().then(() => {
            card.classList.add('is-playing');
          }).catch(() => {
            card.classList.remove('is-playing');
          });
        } else {
          // Card scrolled out \u2014 pause and reset
          preview.pause();
          preview.currentTime = 0;
          card.classList.remove('is-playing');
        }
      });
    }, {
      threshold: [0, 0.2, 0.5]
    });

    // Observe all media-slot cards that have a preview video
    document.querySelectorAll('.media-slot[data-video-src]').forEach((card) => {
      cardAutoplayObserver.observe(card);
      const openCardVideo = () => window.openVideoModal(card.dataset.videoSrc);
      card.addEventListener('click', openCardVideo);
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openCardVideo();
      });
    });
  

  } catch(e) { console.error(e); }
})();
})();
